@let hasShiftUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.Shift);
@let isDisabled = !hasShiftUpdatePermission || isLoading;
<div
  nz-tooltip
  [nzTooltipTitle]="
    !hasShiftUpdatePermission ? ('general.forbidden_action' | translate) : null
  "
  class="assign-shift-button ps-3 pe-2"
>
  <div class="d-flex justify-content-between gap-1">
    <button
      class="assign-shift-btn text-white d-flex align-items-center gap-1 assign-shift-btn-width"
      (click)="createAssignmentJob.emit()"
      nz-button
      [disabled]="isDisabled"
      [nzLoading]="isLoading"
    >
      @if (!isLoading) {
        <fa-icon [icon]="faSparkles" class="me-1"></fa-icon>
      }
      {{ 'page.shift_timeline.assign_all_shift' | translate }}
    </button>
    <button
      class="settings-shift-btn text-white d-flex align-items-center settings-shift-btn-width"
      nz-button
      [disabled]="isLoading"
      (click)="openOptimizerSettingsDrawer.emit()"
    >
      <fa-icon [icon]="faCog" class="custom-cog"></fa-icon>
    </button>
  </div>
</div>
